import { AlertState } from './model'
import * as actions from './actions'
import { AlertActions } from './actions'

const initialState: AlertState = <AlertState> {
  alerts: [],
  filtered: [],
  loading: false,
  filters: {
    state: 'ALL',
    severity: 'ALL',
    resource: 'ALL',
    type: 'basic'
  }
}

const reducer = (state: AlertState = initialState, action: AlertActions): AlertState => {
  switch (action.type) {
    case actions.LoadingAlerts:
      return {
        ...state,
        loading: true
      }
    case actions.ChangeAlerts:
      return {
        ...state,
        loading: false,
        alerts: action.payload.alerts,
      }
    case actions.ChangeFilteredAlerts:
      return {
        ...state,
        loading: false,
        filtered: action.payload.filtered
      }

    case actions.ChangeSearchInput:
      return {
        ...state,
        filters: {...state.filters, search: action.payload.searchInput}
      }

    case actions.SaveNextLink:
      return {
        ...state,
        nextLink: action.payload.nextLink
      }

    case actions.SaveFilteredNextLink:
      return {
        ...state,
        filteredNextLink: action.payload.filteredNextLink
      }

    case actions.ChangeFilterValue:
      const filters = {...state.filters}
      filters[action.payload.key] = action.payload.value

      return {
        ...state,
        filters
      }

    default:
      return state
  }
}

export default reducer
